import React, { Fragment, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Slices/ParamSlice";
import { useAppDispatch } from "../../Core/store.hooks";
import { getSettingsSelector, updateSettings } from "../../Settings/Slice";
import { DropDownList } from "@progress/kendo-react-dropdowns";

interface IFilters {

}

const Filters = (props: IFilters) => {
  const [selectedCustomerLayout, setSelectedCustomerLayout] = useState(
    "Tab Strip"
  );
  const [selectedMachineLayout, setSelectedMachineLayout] = useState(
    "Tab Strip"
  );

  const globalParams = useSelector(getParamsSelector);
  const settings = useSelector(getSettingsSelector);

    useEffect(() => {
       // console.log("SETTINGS",settings);
        if (settings.customerLayoutSession != null) {
            setSelectedCustomerLayout(settings.customerLayoutSession);
        }
      if (settings.machineLayoutSession != null) {
//console.log(settings.machineLayoutSession);
          setSelectedMachineLayout(settings.machineLayoutSession);
      }
  }, [settings]);

    //useEffect(() => {
    //    console.log(globalParams)
    //}, [globalParams]);

  const dispatch = useAppDispatch();
 
  const customerOptionHandler = (e: any) => {
    setSelectedCustomerLayout(e.target.value);
    const newSettings: any = Object.assign({}, settings);
    newSettings.customerLayoutSession = e.target.value;

    dispatch<any>(updateSettings(newSettings));
  };
  const renderCustomerOptions = () => {
    let customerOptions: any = ["App Default Dashboard", "Tab Strip"];
    let dbList = JSON.parse(localStorage.getItem("savedDashboardCustomer"));

    if (dbList != null && dbList != undefined) {
        for (var i = 0; i < dbList.length; i++) {
            if (dbList[i].dbName != null && dbList[i].dbName != "" && dbList[i].dbName != undefined) {

                customerOptions.push(dbList[i].dbName);
            }
      }
    }
    return (
      <div className="k-textbox-container metricCombo">
        <label className="k-label">Select Customer Dashboard</label>
        <DropDownList
          data={customerOptions}
          value={selectedCustomerLayout}
          onChange={customerOptionHandler}
        />
      </div>
    );
  };
  const machineOptionHandler = (e: any) => {
    setSelectedMachineLayout(e.target.value);
    const newSettings: any = Object.assign({}, settings);
    newSettings.machineLayoutSession = e.target.value;

    dispatch<any>(updateSettings(newSettings));
  };
  const renderMachineOptions = () => {
    let machineOptions: any = ["App Default Dashboard", "Tab Strip"];
    let dbList = JSON.parse(localStorage.getItem("savedDashboardMachine"));

    if (dbList != null && dbList != undefined) {
        for (var i = 0; i < dbList.length; i++) {
            if (dbList[i].dbName != null && dbList[i].dbName != "" && dbList[i].dbName != undefined) {

                machineOptions.push(dbList[i].dbName);
            }
        }
    }
    return (
      <div className="k-textbox-container metricCombo">
        <label className="k-label">Select Machine Dashboard</label>
        <DropDownList
          data={machineOptions}
          value={selectedMachineLayout}
          onChange={machineOptionHandler}
        />
      </div>
    );
  };
  const renderDashboardTypeOptions = () => {
    if (globalParams.mainMachineSerialNo == null) {
      return renderCustomerOptions();
    } else {
      return renderMachineOptions();
    }
  };
  function renderContent() {
    return (
      <Fragment>
        {renderDashboardTypeOptions()}
      </Fragment>
    );
  }
  return <Fragment>{renderContent()}</Fragment>;
};

export default Filters;
